module.exports = __webpack_public_path__ + "img/arrows.c511520b.png";